import { FunctionalComponent, ComponentChild, h } from "preact";
import { useTranslation } from "react-i18next";
import { ExclamationIcon } from "@heroicons/react/solid";
import Four04 from "../404";
import { useTrackPageView } from "../../analytics";

interface Props {
  error: ComponentChild;
  errCode: number;
  onRetry?: () => void;
}

const ErrorInline: FunctionalComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { error, errCode, onRetry } = props;
  const shouldShowRetry = errCode !== 403;

  useTrackPageView(`error:${errCode}`);

  if (errCode === 404) {
    return <Four04 />;
  }

  return (
    <div
      className="
      inline-block
      align-bottom
      bg-white
      rounded-lg
      px-4
      pt-5
      pb-4
      text-left
      overflow-hidden
      shadow-xl
      transform
      transition-all
      w-full
      sm:my-8
      sm:align-middle
      sm:p-6
    "
    >
      <div className="sm:flex sm:items-start">
        <div
          className="
          mx-auto
          flex-shrink-0 flex
          items-center
          justify-center
          h-12
          w-12
          rounded-full
          bg-danger-subtler
          sm:mx-0
          sm:h-10
          sm:w-10
        "
        >
          <ExclamationIcon
            className="h-6 w-6 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {t("error.title.message")}
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">{error}</p>
          </div>
        </div>
      </div>

      {onRetry && shouldShowRetry ? (
        <div className="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
          <button
            type="button"
            className="
            inline-flex
            justify-center
            w-full
            rounded-md
            border border-transparent
            shadow-sm
            px-4
            py-2
            bg-red-600
            text-base
            font-medium
            text-white
            hover:bg-red-700
            focus:outline-none
            focus:ring-2 focus:ring-offset-2 focus:ring-red-500
            sm:w-auto
            sm:text-sm
          "
            onClick={() => {
              onRetry();
            }}
          >
            {t("error.retry.message")}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ErrorInline;
